<template>
	<div>
		<div class="main">
			<div class="main_top">
				<p class="showHand one-txt-cut" @click="add">新增收货地址</p>
				<span>您已创建{{addressNav.length}}个收货地址</span>
			</div>
			<div class="list" v-for="(item,index) in addressNav" :key="index">
				<ul class="list_left">
					<li>
						<p class="one-txt-cut one-txt-cut_length">{{item.addr_name}}</p>
						<p>{{item.addr_province}}</p>
						<span v-show="item.addr_status" class="one-txt-cut">默认地址</span>
					</li>
					<li>
						<p style="margin-left: 18px;">收货人：</p>
						<span style="display: inline-block;flex: 1;" class="one-txt-cut">{{item.addr_name}}</span>
					</li>
					<li>
						<p>所在地区：</p>
						<span style="display: inline-block;flex: 1;" class="one-txt-cut">{{item.addr_province}}{{item.addr_market}}{{item.addr_county}}</span>
					</li>
					<li>
						<p>详细地址：</p>
						<span style="display: inline-block;flex: 1;" class="one-txt-cut">{{item.addr_address}}</span>
					</li>
					<li>
						<p>手机号码：</p><span>{{item.addr_phone?item.addr_phone.slice(0,3)+'****'+item.addr_phone.slice(-4):''}}</span>
					</li>
					<li>
						<p>公司名称：</p>
						<span style="display: inline-block;flex: 1;" class="one-txt-cut">{{item.addr_company}}</span>
					</li>
				</ul>
				<ul class="list_ri">
					<li class="showHand"><img src="../../../assets/img/comm/icon_cha.png" @click="deleteAddress(item,index)">
					</li>
					<li class="showHand" @click="edit(item,index)">编辑</li>
				</ul>
			</div>
			<div class="main_top main_bot">
				<p class="showHand one-txt-cut" @click="add">新增收货地址</p>
				<span>您已创建{{addressNav.length}}个收货地址</span>
			</div>
		</div>
		<!-- 弹出 修改地址弹框 -->
		<div class="Maddress" v-if="editStatus">
			<div class="Maddress_nav">
				<div class="Maddress_nav_top">
					<p>编辑地址</p>
					<img src="../../../assets/img/comm/icon_cha.png" @click="cancle" class="showHand">
				</div>
				<p class="mtitle">编辑收货地址</p>
				<ul class="addDetail">
					<li class="li_top">
						<p style="font-size: 16px;color: #999999;">当前配送至</p>
						<p class="li_top_add">中国大陆</p>
					</li>
					<ul class="form">
						<li>
							<p><span style="font-size: 16px;color: #FF0000;">*</span><span>地址信息</span></p>
							<p @click="pickerVisible = true" class="alert">
								<!-- {{addssTxt?addssTxt:'请选择省/市/区/街道'}} -->
								{{addssTxt?addssTxt:updateAddress&&updateAddress?updateAddress.addr_province+updateAddress.addr_market+updateAddress.addr_county:'请选择省/市/区/街道'}}
							</p>
						</li>
						<li>
							<p><span class="minput">*</span><span>详细地址</span></p>
							<textarea v-model="updateAddress.addr_address"
								placeholder="请输入详细地址信息,如道路/门牌号/小区/楼栋号/单元等信息"></textarea>
						</li>
						<li>
							<p><span class="minput">*</span><span>公司名称</span></p>
							<input type="text" name="" v-model="updateAddress.addr_company" value="" placeholder="请输入公司名称" />
						</li>
						<li>
							<p><span class="minput">*</span><span>收货人姓名</span></p>
							<input type="text" name="" v-model="updateAddress.addr_name" value="" placeholder="长度不超过25字符" />
						</li>
						<li>
							<p><span class="minput">*</span><span>手机号码</span></p>
							<input type="number" v-model="updateAddress.addr_phone" value="" maxlength="11"
								oninput="if(value.length>11)value=value.slice(0,11)" placeholder="请输入手机号码" />
						</li>
					</ul>
					<li class="lastli">
						<img :src="updateAddress&&updateAddress.addr_status?require('../../../assets/img/privacy/addressSelected.png')
						:require('../../../assets/img/privacy/addressSelect.png')" class="choice" @click="selectStatus">
						<p class="mselect">设置为默认收货地址</p>
					</li>
					<button type="button" class="showHand" @click="editSubmit">保存</button>
				</ul>
			</div>
		</div>
		<!-- 弹出 新增地址弹框 -->
		<div class="Maddress" v-if="addStatus">
			<div class="Maddress_nav">
				<div class="Maddress_nav_top">
					<p>创建地址</p>
					<img src="../../../assets/img/comm/icon_cha.png" @click="cancle" class="showHand">
				</div>
				<p class="mtitle">新增收货地址</p>
				<ul class="addDetail">
					<li class="li_top">
						<p style="font-size: 16px;color: #999999;">当前配送至</p>
						<p class="li_top_add">中国大陆</p>
					</li>
					<ul class="form">
						<li>
							<p><span style="font-size: 16px;color: #FF0000;">*</span><span>地址信息</span></p>
							<span @click="pickerVisible = true" class="alert">{{addssTxt?addssTxt:'请选择省/市/区/街道'}}</span>
						</li>
						<li>
							<p><span class="minput">*</span><span>详细地址</span></p>
							<textarea v-model="updateAddress.detailaddress"
								placeholder="请输入详细地址信息,如道路/门牌号/小区/楼栋号/单元等信息"></textarea>
						</li>
						<li>
							<p><span class="minput">*</span><span>公司名称</span></p>
							<input type="" name="" id="" v-model="updateAddress.company" value=""
								placeholder="请输入公司名称" />
						</li>
						<li>
							<p><span class="minput">*</span><span>收货人姓名</span></p>
							<input type="text" name="" value="" placeholder="长度不超过25字符" v-model="updateAddress.name"
								maxlength="25" oninput="if(value.length>25)value=value.slice(0,25)" />
						</li>
						<li>
							<p><span class="minput">*</span><span>手机号码</span></p>
							<input type="number" name="phone" id="" v-model="updateAddress.phone" maxlength="11"
								oninput="if(value.length>11)value=value.slice(0,11)" value="" placeholder="请输入手机号码" />
						</li>
					</ul>
					<li class="lastli">
						<img :src="updateAddress&&updateAddress.addr_status?require('../../../assets/img/privacy/addressSelected.png')
						:require('../../../assets/img/privacy/addressSelect.png')" class="choice" @click="selectStatus">
						<p class="mselect">设置为默认收货地址</p>
					</li>
					<button type="button" class="showHand" @click="throttle(addSubmit,3000)">保存</button>
				</ul>
			</div>
		</div>


		<VuePicker :data="pickData" :layer="3" :showToolbar="true" @cancel="cancel" @confirm="confirm"
			:visible.sync="pickerVisible" />
	</div>
</template>

<script>
	import { selByList,addAppCAddress,delAppCAddress,upAppCAddress } from "@/api/address.js"
	import selAddress from "../../../components/selAddress.vue"
	let _self;
	import VuePicker from 'vue-pickers'
	import cityData from 'vue-pickers/city-data.js'
	const deepFreeze = function(obj) {
		var propNames = Object.getOwnPropertyNames(obj);
		propNames.forEach(function(name) {
			var prop = obj[name];
			if (typeof prop == 'object' && prop !== null) {
				deepFreeze(prop);
			}
		})
		return Object.freeze(obj)
	}
	// 冻结以提升性能
	const freezeCityData = deepFreeze(cityData)
	export default {
		name: "",
		data() {
			return {
				userInfo:null,
				updateAddress: {
					addr_market: null,
					addr_province: null,
					addr_county:null,
					addr_address: null,
					addr_name: null,
					addr_phone: null,
					addr_company: null
				},
				//循环遍历地址信息
				addressNav: [
					// {
					// 	status: true,
					// 	name: "王大壮",
					// 	region: "河北",
					// 	location: "河北省石家庄市裕华区东苑街道",
					// 	detailaddress: "槐北路366号人寿保险公司宿舍",
					// 	phone: "12345678910",
					// 	company: "河北骊光科技有限公司"
					// }
				],
				// 选中编辑的下标
				selectindex: null,
				//修改弹框状态
				editStatus: false,
				message: '显示',
				// 新增地址弹框状态
				addStatus: false,
				//点击确认删除
				delItem: null,
				showToolbar: true,
				pickerVisible: false,
				pickData: freezeCityData,
				result: '',
				// 显示的地址
				addssTxt: '',
				//地址选择数组（省市区）
				detailAddressArr:null,
				//是否允许请求
				isrequest:true,
			}
		},
		beforeCreate() {
			_self = this;
		},
		created() {
			// 用户信息处理===用户信息传递
			_self.userInfo=this.getUInfo();
			// console.log("用户信息",_self.userInfo);
			//获取地址信息
			_self.getAddressList();
		},
		// 方法集
		methods: {
			//获取地址信息
			getAddressList(){
				selByList({
					userId:_self.userInfo.userId,
					page:'1',
					size:'50',
				}).then(res=>{
					if(res.data&&res.code==200){
						_self.addressNav=res.data.list;
					}
					//取消弹框
					_self.cancle();
				})
			},
			//删除地址信息
			deleteAddress(item,index) {
				// 防止频繁请求
				if(!_self.isrequest) return;
				_self.isrequest=false;
				// 接口请求
				delAppCAddress({
					addrId:item.addr_id
				}).then(res=>{
					if(res.code==200){
						// 提示成功
						_self.$message({
							message:res.data,
							type:'success'
						})
						// 删除一个
						_self.addressNav.splice(index,1);
					}
					_self.isrequest=true;
				})
			},
			//点击弹出修改框
			edit(item,index) {
				// 定义当前选中的下标
				_self.selectindex = index;
				// return;
				_self.editStatus = !_self.editStatus;
				if (_self.editStatus) {
					_self.message = '隐藏'
					// 修改地址内容保存到变量
					_self.updateAddress = _self.addressNav[index]
					
				} else {
					_self.message = '显示'
				}
			},
			selectStatus() {
				// 选中状态取反
				_self.updateAddress.addr_status = !_self.updateAddress.addr_status;
				// 强制刷新
				this.$forceUpdate()
			},
			//点击弹出新增框
			add() {
				_self.addStatus = !_self.addStatus;
				if (_self.addStatus) {
					_self.message = '隐藏'
					_self.editStatus = false
				} else {
					_self.message = '显示'
				}
			},
			//添加地址
			addSubmit() {
				// 对新增地址中 所输入的内容进行判断
				if (!_self.addssTxt && _self.$eror('请选择正确的地址'), _self.addssTxt ? false : true) return;
				if (!_self.updateAddress.detailaddress && _self.$eror('请输入正确的详细地址'), _self.updateAddress.detailaddress ?
					false : true) return;
					if (!_self.updateAddress.company && _self.$eror('请输入正确的公司名称'), _self.updateAddress.company ? false : true) return;
				if (!_self.updateAddress.name && _self.$eror('请输入正确的姓名'), _self.updateAddress.name ? false : true) return;
				if (!_self.updateAddress.phone && _self.$eror('请输入正确的手机号'), _self.updateAddress.phone ? false : true)
					return;
				// if(!_self.updateAddress.phone || _self.updateAddress.phone && _self.updateAddress.phone.length!=11){
				// 	_self.$eror('请输入正确的手机号')
				// 	return false;
				// }
				let myreg=/^[1][0-9]{10}$/;
				if (!myreg.test(_self.updateAddress.phone)) {
					_self.$eror('请输入正确的手机号')
					return false;
				}
				if(!_self.isrequest) return;
				_self.isrequest=false;
				
				//新增接口
				addAppCAddress({
					addrProvince:_self.detailAddressArr &&_self.detailAddressArr.length?_self.detailAddressArr[0].label:'',
					addrMarket:_self.detailAddressArr &&_self.detailAddressArr.length?_self.detailAddressArr[1].label:'',
					addrAddress:_self.updateAddress.detailaddress,
					addrName:_self.updateAddress.name,
					addrPhone:_self.updateAddress.phone,
					addrCompany:_self.updateAddress.company,
					userId:_self.userInfo.userId,
					addrStatus:_self.updateAddress.addr_status==true?2:0,
					addrCounty:_self.detailAddressArr && _self.detailAddressArr.length?_self.detailAddressArr[2].label:'',
				}).then(res=>{
					if(res.code==200){
						// 提示新增成功
						_self.$message({
							message:'地址新增成功',
							type:'success'
						})
						_self.isrequest=true;
						//清空弹框中的内容
						_self.updateAddress = {
							location: null,
							region: null,
							detailaddress: null,
							name: null,
							phone: null,
							company: null
						};
						//清空显示地址
						_self.addssTxt = '';
						//查询列表
						_self.getAddressList();
					}
				})
			},
			//修改地址
			editSubmit() {
				if (!_self.updateAddress.addr_address && _self.$eror('请输入正确的详细地址'), _self.updateAddress.addr_address ?
					false : true) return;
					if (!_self.updateAddress.addr_company && _self.$eror('请输入正确的姓名'), _self.updateAddress.addr_company ? false : true) return;
				if (!_self.updateAddress.addr_name && _self.$eror('请输入正确的姓名'), _self.updateAddress.addr_name ? false : true) return;
				if (!_self.updateAddress.addr_phone && _self.$eror('请输入正确的手机号'), _self.updateAddress.addr_phone ? false : true)
					return;
				// if(!_self.updateAddress.addr_phone || _self.updateAddress.phone && _self.updateAddress.addr_phone.length!=11){
				// 	_self.$eror('请输入正确的手机号')
				// 	return false;
				// }
				let myreg=/^[1][0-9]{10}$/;
				if (!myreg.test(_self.updateAddress.addr_phone)) {
					_self.$eror('请输入正确的手机号')
					return false;
				}


				// 定义省市区
				let addrProvince=_self.detailAddressArr  && _self.detailAddressArr[0]?_self.detailAddressArr[0].label:_self.updateAddress.addr_province;
				let addrMarket=_self.detailAddressArr  && _self.detailAddressArr[1]?_self.detailAddressArr[1].label:_self.updateAddress.addr_market;
				let addrCounty=_self.detailAddressArr  && _self.detailAddressArr[2]?_self.detailAddressArr[2].label:_self.updateAddress.addr_county;
				
				// 频繁请求阻止
				if(!_self.isrequest) return;
				_self.isrequest=false;
				// 接口请求
				upAppCAddress({
					addrAddress:_self.updateAddress.addr_address,
					addrCompany:_self.updateAddress.addr_company,
					addrProvince:addrProvince,
					addrMarket:addrMarket,
					addrCounty:addrCounty,
					addrId:_self.addressNav[_self.selectindex].addr_id,
					addrName:_self.updateAddress.addr_name,
					addrPhone:_self.updateAddress.addr_phone,
					addrStatus:!_self.updateAddress.addr_status?0:2,
					userId:_self.userInfo.userId
				}).then(res=>{
					if(res.code==200){
						// 提示新增成功
						_self.$message({
							message:res.data,
							type:'success'
						})
						// // 改变默认地址的状态
						let newData = JSON.parse(JSON.stringify(_self.updateAddress));
						let newArr= JSON.parse(JSON.stringify(_self.addressNav));
						if (newData.addr_status) {
							newArr.forEach((item, index) => {
								if( _self.selectindex==index){
									item=newData;
									item.addr_status = true;
								}else{
									item.addr_status = false;
								}
							})
							_self.$set(_self,'addressNav', newArr);
						}else{
							// 改变内容 找到数组      找到选择的值          新值
							_self.$set(_self.addressNav, _self.selectindex, newData);
						}
						_self.isrequest=true;
						//清空弹框中的内容
						_self.updateAddress = {
							location: null,
							region: null,
							detailaddress: null,
							name: null,
							phone: null,
							company: null
						};
						//清空显示地址
						_self.addssTxt = '';
						//查询列表
						_self.cancle();
					}
				})
			},
			// 关闭弹框
			cancle() {
				_self.editStatus = false
				_self.addStatus = false
			},


			// 地址选择器
			// 关闭选择器
			cancel() {
				this.result = '';
				this.addssTxt = '';
			},
			// 确定事件触发
			confirm(res) {
				let obj = JSON.parse(JSON.stringify(res))
				if (obj[0].children) {
					delete obj[0].children
				}
				if (obj[1].children) {
					delete obj[1].children
				}
				if (obj[2].children) {
					delete obj[2].children
				}
				this.result = JSON.stringify(obj);


				// 定义显示数据
				let newTxt = '';
				res.forEach((item, index) => {
					newTxt = newTxt + item.label;
				})
				// 定义编辑下的省市区
				_self.updateAddress.location = newTxt;
				_self.updateAddress.addr_province = res[0].label;
				_self.updateAddress.addr_market = res[1].label;
				_self.updateAddress.addr_county = res[2].label;
				// 定义显示地址
				_self.addssTxt = newTxt;
				_self.updateAddress.region = res[0].label.slice(0, 2);
				_self.detailAddressArr=res;
			},
			toCopy() {
				copy(copyText)
				this.$emit('tips')
			}
		},
		// 组件集
		components: {
			selAddress,
			VuePicker
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},
		// 过滤器
		filters: {

		},
		// 实例销毁
		destroyed() {

		},
		// 页面跳转信息
		beforeRouteEnter(to, from, next) {
			// 判断是否登录===登录，允许进入||未登录，返回登陆页
			let info = localStorage.getItem('userInfo');
			info ? next() : next('/Login')
		},
	}
</script>

<style scoped>
	.main {
		width: 100%;
		background: rgba(255, 255, 255, 0.72);
		padding: 20px 30px;
		box-sizing: border-box;
	}

	.main_top {
		height: 40px;
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.main_bot {
		margin-top: 30px;
	}

	.main_top p {
		width: 128px;
		height: 36px;
		border: 1px solid #e62129;
		border-radius: 2px;
		font-size: 16px;
		font-weight: 400;
		color: #e62129;
		letter-spacing: 2px;
		padding: 7px 8px;
		box-sizing: border-box;
		margin-right: 15px;
	}

	.main_top span {
		font-size: 16px;
		color: #999999;
		letter-spacing: 2px;
	}

	.list {
		width: 100%;
		overflow: hidden;
		border: 1px solid #cccccc;
		margin-top: 30px;
		padding: 20px 30px;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
		justify-content: space-between;
	}

	.list_left {
		display: flex;
		flex-direction: column;
		flex: 1;
		overflow: hidden;
	}

	.list_left li {
		display: flex;
		width: 100%;
		overflow: hidden;
		flex-direction: row;
		margin-bottom: 15px;
	}

	.list_left li p {
		font-size: 16px;
		text-align: right;
		color: #999999;
		letter-spacing: 2px;
	}

	.list_left li span {
		font-size: 16px;
		color: #666666;
		letter-spacing: 2px;
	}

	.list_left li:nth-child(1) {
		display: flex;
		flex-direction: row;
		margin-bottom: 25px;
	}

	.list_left li:nth-child(1) p {
		font-size: 22px;
		color: #333333;
		letter-spacing: 3px;
		margin-right: 18px;
	}

	.list_left li:nth-child(1) span {
		width: 84px;
		height: 30px;
		background: #ff6e00;
		font-size: 16px;
		color: #ffffff;
		letter-spacing: 2px;
		padding: 5px 6px;
		box-sizing: border-box;
	}

	.list_ri {
		width: 40px;
		height: 220px;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		font-weight: 400;
		color: #3239ff;
		letter-spacing: 2px;
	}

	.list_ri li img {
		width: 20px;
		height: 20px;
	}

	/* 修改弹框 */
	.Maddress {
		position: fixed;
		top: 0;
		left: 0;
		z-index: 210;
		width: 100%;
		height: 100vh;
		background: rgba(0, 0, 0, 0.5);
	}

	.Maddress_nav {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		width: 830px;
		height: 653px;
		background: #ffffff;
		padding: 30px 30px;
		box-sizing: border-box;
	}

	.Maddress_nav_top {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		font-size: 24px;
		font-weight: 400;
		color: #000000;
		letter-spacing: 3px;
	}

	.Maddress_nav_top img {
		width: 20px;
		height: 20px;
		display: block;
	}

	.addDetail {
		width: 620px;
		margin: 0 80px;
		padding: 0 20px;
		box-sizing: border-box;
	}

	.li_top {
		width: 100%;
		height: 44px;
		background: #f1f1f1;
		padding: 11px 30px;
		box-sizing: border-box;
		display: flex;
		flex-direction: row;
	}

	.form {
		width: 580px;
		padding: 0 20px 0 20px;
		box-sizing: border-box;
	}

	.form li {
		display: flex;
		flex-direction: row;
		align-items: center;
		justify-content: space-between;
		font-size: 16px;
		color: #666666;
		letter-spacing: 2px;
		padding: 0 0 20px 0;
		box-sizing: border-box;
		/* margin-bottom: 20px; */
	}

	.form li:nth-child(1) {
		padding-top: 20px;
		box-sizing: border-box;
	}

	.lastli {
		display: flex;
		flex-direction: row;
		padding: 0 130px;
		box-sizing: border-box;
	}

	.form li p {
		display: flex;
		flex-direction: row;
		align-items: center;
	}

	.alert {
		width: 430px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 11px 15px;
		box-sizing: border-box;
	}

	.form li textarea {
		width: 430px;
		height: 62px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 10px 15px;
		box-sizing: border-box;
	}

	.form li input {
		width: 430px;
		height: 44px;
		background: #ffffff;
		border: 1px solid #cccccc;
		border-radius: 2px;
		color: #999999;
		font-size: 16px;
		padding: 11px 15px;
		box-sizing: border-box;
	}

	.choice {
		width: 24px;
		height: 24px;
	}

	button {
		width: 72px;
		height: 30px;
		background: #3239ff;
		font-size: 14px;
		font-weight: 400;
		color: #ffffff;
		letter-spacing: 1px;
		margin: 30px 0 30px 126px;
	}

	.mtitle {
		font-size: 16px;
		color: #ff6e00;
		margin: 40px 60px 15px 60px;
	}

	.minput {
		font-size: 16px;
		color: #FF0000;
	}

	.mselect {
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		margin-left: 10px;
	}

	.li_top_add {
		font-size: 16px;
		font-weight: 400;
		color: #000000;
		margin-left: 20px;
	}

	.one-txt-cut_length {
		max-width: 100px;
	}
</style>
